/** @format */

import { useSelector } from "react-redux";
import React, { useEffect, useState } from "react";
import {
  GoogleMap,
  InfoWindow,
  LoadScript,
  Marker,
  Polygon,
  useLoadScript,
} from "@react-google-maps/api";
import MapElements from "./MapElements";
import MarkerPopup from "./MarkerPopup";
import { getEnv } from "../../../lib/env";

export default function Map({ stations, center, isfilter }) {
  const { isLoaded } = useLoadScript({
    googleMapsApiKey: getEnv('REACT_APP_API_KEY'),
  });

  if (!isLoaded) return <div>Loading . . .</div>;
  return <Mapping stations={stations} c={center} isfilter={isfilter} />;
}

function Mapping({ stations, c, isfilter }) {
    const [map, setMap] = useState(null);
    const [zoom, setZoom] = useState(6.5);
    const [selected, setSelected] = useState(null);
    const newCenter = useSelector((state) => state.map);
    const [center, setCenter] = useState({ lat: 41.5636681, lng: 62.695678 });

  useEffect(() => {
    if (newCenter) {
      setCenter(newCenter.defaultCenter);
      setZoom(newCenter.defaultZoom);
    }
  }, [newCenter]);

  useEffect(() => {
    if (c && c.lat && c.lng) {
      setCenter(c);
      setZoom(20);
      if (map) {
        map.panTo(c);
        map.zoom = 20;
      }
    }
  }, [c]);

  useEffect(() => {
    setSelected(null);
  }, [isfilter]);

  return (
    <GoogleMap
      mapContainerClassName='MapContainer'
      zoom={zoom}
      center={center}
      mapTypeId='satellite'
      onLoad={(map) => setMap(map)}>
      {selected ? (
        <InfoWindow
          position={{
            lat: parseFloat(selected.lat),
            lng: parseFloat(selected.lan),
          }}
          onCloseClick={() => setSelected(null)}>
          <MarkerPopup st={selected} />
        </InfoWindow>
      ) : null}

      {stations.length > 0 ? (
        <MapElements setSelected={setSelected} stations={stations} />
      ) : null}
    </GoogleMap>
  );
}
